import styled from "styled-components";

const Image = styled.img`
  display: inline-block;
  height: auto;
  opacity: 0.4;
  width: 100%;
`;

export default Image;
